import { liveValidatePattern } from '../validate/pattern';
import { liveValidateMax } from '../validate/max';
import { liveValidateMaxLength } from '../validate/maxlength';
import { liveValidateMin } from '../validate/min';
import { liveValidateBlur } from '../validate/blur';
import { liveValidateSubmit, validateSubmit, autoFocusFirstOnSubmitError } from '../validate/submit';

export function validateOthercamsForm(form: HTMLFormElement): void {
    form.setAttribute('novalidate', 'novalidate');

    const inputs = [form.ageFrom, form.ageTo];

    for (const el of inputs) {
        liveValidateMin(el);
        liveValidateMax(el);
        liveValidateMaxLength(el);
        liveValidatePattern(el);
        liveValidateBlur(el);
    }

    liveValidateSubmit(form);

    form.addEventListener('submit', function (this: HTMLFormElement, e: Event) {
        const errors = [...validateSubmit(inputs)];
        const valid = errors.indexOf(false) === -1;

        if (!valid) {
            form.classList.add('focus-visible');
            autoFocusFirstOnSubmitError(this);

            e.preventDefault();

            return false;
        }

        // Remove empty parameters (disabled empty fields are not sent via GET request) on form submit
        // Ex: /search-cams?typeOfView=0&s%5BchNick%5D=&s%5BcatID%5D=0&s%5BageFrom%5D=&s%5BageTo%5D=&s%5BsexID%5D=&s%5BprefID%5D=&s%5BzodiacID%5D=&s%5BbuildID%5D=&s%5BhairID%5D=&s%5BlenHairID%5D=&s%5BeyeID%5D=&s%5BbustID%5D=&s%5BlangID%5D=&s%5BcoID%5D=&s%5BethID%5D=&s%5BoptActivityID%5D=&s%5Brole2ID%5D=&buttonSearch= will be sent as /search-cams?type=0&s%5BcatID%5D=0
        const inputFields: NodeListOf<HTMLInputElement | HTMLSelectElement> = this.querySelectorAll('input[type="text"], select, button');
        inputFields.forEach((inputField: HTMLInputElement | HTMLSelectElement) => {
            if (!inputField.value) {
                inputField.setAttribute('disabled', 'disabled');
            }
        });

        return;
    });
}
